import React from 'react';
import { RandomCssDemo } from './RandomCssDemo';
import { makeDivs } from './utils';

const AURORA_HTML = makeDivs(29, 'beam');

export function AuroraExample() {
  return (
    <RandomCssDemo
      title="Aurora"
      htmlBody={AURORA_HTML}
      scaffoldCss={`
        * { box-sizing: border-box; }
        body {
          position: absolute;
          margin: 0;
          left: -100px;
          right: -100vw;
          top: 0;
          bottom: 0;
          background: #000;
          overflow: hidden;
          display: flex;
          align-items: stretch;
          justify-content: flex-start;
        }

        .beam {
          flex: 1 1 auto;
          scale: 1.5;
          translate: 0 -10%;
          transform-origin: top center;
          border-radius: 0 0 50% 50%;
        }

      `}
      cssCodeInit={` @property --skew {
  syntax: "<angle>";
  inherits: true;
  initial-value: 0deg;
}

@property --length {
  syntax: "<percentage>";
  inherits: true;
  initial-value: 100%;
}

.beam {
  background: linear-gradient(
    to bottom,
    hsl(random(100, 280) 100% 50%),
    hsl(random(100, 280) 50% 0%) var(--length)
  );

  mix-blend-mode: plus-lighter;
  filter: blur(8px);
  animation:
    rotate random(3s, 8s) ease-in-out infinite alternate,
    grow random(2s, 11s) ease-in-out infinite alternate,
    move random(8s, 12s) ease-in-out infinite alternate;
  animation-delay: random(-5s, 0s), random(-5s, 0s), random(-8s, 0s);
  transform: perspective(300px) rotateX(20deg) skewX(var(--skew));

}

@keyframes rotate {
  from {
    --skew: random(10deg, 14deg);
  }
  to {
    --skew: random(12deg, 18deg);
  }
}

@keyframes grow {
  from {
    --length: random(20%, 50%);
  }
  to {
    --length: random(40%, 60%);
  }
}

@keyframes move {
  from {
    translate: random(-2vw, 0vw) -10%;
  }
  to {
    translate: random(0vw, 2vw) -10%;
  }
}`}
    />
  );
}
